<script>
    import Tooltip from './Tooltip.svelte';
    import Time from './Time.svelte';
    import orderBy from 'lodash/orderBy'
    export let archive;
    let y;
	// $: console.log(y)
	$: (y > 250) ? showFloat = true : showFloat = false;
    let showFloat = false;

    const currencyList = [
  "USD",
  "EUR",
  "RUB",
  "KGS",
  "CNY",
  "GBP",
  "CHF",
  "UZS",
  "JPY",
  "AUD",
  "TRY",
  "AED",
  "UAH",
  "THB",
  "INR",
  "EGP",
  "CAD",
  "KPW",
  "KRW",
  "MNT",
  'TMT',
  'GEL',
  "GOLD",
  "AZN",
  "BHD",
  "AMD",
  "BYN",
  "BRL",
  "HUF",
  "HKD",
  "DKK",
  "IRR",
  "KWD",
  "MYR",
  "MXN",
  "MDL",
  "NOK",
  "PLN",
  "SAR",
  "XDR",
  "SGD",
  "TJS",
  "CZK",
  "SEK",
  "ZAR",
  "ILS",
  "QAR",
  "VND",
  "LKR",
  "OMR",
  "PKR",
  "MVR",
  "IDR",
]
    export let items;
    let visibleCurrency = ['USD', 'EUR', 'RUB'];
    let sortingOptions = ['date','desc'];
    const onSortTime = () => {
        sortingOptions = ['date','desc'];
        items = orderBy(items, ['mainsort', 'date'], ['desc', 'desc']);        
    }
    const onSortCurrency = (a, b) => {
        if (sortingOptions[0] == 'data.' + a + '.' + b) {
            sortingOptions[1] = sortingOptions[1] === 'asc' ? 'desc' : 'asc'
        } else {
            sortingOptions = ['data.' + a + '.' + b, b ? 'asc' : 'desc'];
        }
        items = orderBy(items, ['mainsort', 'data.' + a + '.' + b], ['desc', sortingOptions[1]]);
    }

    let filterActive = false;
    let filter = "";
    onSortTime();
    $: filteredItemsList = items.filter(item => item.name.toLowerCase().indexOf(filter.toLowerCase()) !== -1 && item.data['USD'][0] > 0);
    
    const calculateAverage = (items) => {
        let data = {};
        items.forEach(item => {
            Object.keys(item.data).forEach(currency=>{
                if(item.data[currency]){
                    if (data[currency] === undefined) {
                        data[currency] = [0,0,0,0];
                    } 
                    if(item.data[currency][0] > 0){
                        data[currency][0] += item.data[currency][0];
                        data[currency][2] += 1;
                    }
                    if(item.data[currency][1] > 0){
                        data[currency][1] += item.data[currency][1];
                        data[currency][3] += 1;
                    }
                }
            })
        })
        return data;
    };
    $: averageData = calculateAverage(filteredItemsList)

</script>
<svelte:window bind:scrollY={y} />
<div class="row pt-2 pb-2 floatTHead" class:float={showFloat}>
    {#each visibleCurrency as currency, i}
    <div class="col nowrap text-center"  class:hidden-xs={i > 0}>
        <span class="controls" on:click={() => {onSortCurrency(currency, 0)}} data-tooltip="Выгодная покупка">
            <svg width="16" height="8">
                <path 
                    fill={sortingOptions[0] == "data." + currency + ".0" ? "#286AA9" : "#999"} 
                    d={sortingOptions[0] == "data." + currency + ".0" && "asc" == sortingOptions[1] ? "M8 0L0 8h16" : "M16 0H0l8 8"} />
            </svg>
        </span>
        <span class="controls">
            <select bind:value={visibleCurrency[i]}>
                {#each currencyList as currency}
                    <option value={currency}>
                        {currency}
                    </option>
                {/each}
            </select>
        </span>
        <span class="controls" on:click={() => {onSortCurrency(currency, 1)}} data-tooltip="Выгодная продажа">
            <svg width="16" height="8">
                <path fill={sortingOptions[0] == "data." + currency + ".1" ? "#4E8E40" : "#999"} 
                d={sortingOptions[0] == "data." + currency + ".1" && "desc" == sortingOptions[1] ? "M16 0H0l8 8" : "M8 0L0 8h16"} />
            </svg>
        </span>
        
    </div>
    {/each}
</div>
<table class="table table-striped table-kurs">
    <thead>
        <tr>
            <th>
                <div class="searchInputContainer" class:open={filterActive} on:click={e=>{ filterActive = true;}}>
                    <div>Обменный пункт</div>
                    {#if filterActive}
                        <input type="text" bind:value={filter}  placeholder="Найти ОП" class="searchInput" autofocus>
                    {/if}
                    <a href="#" on:click|stopPropagation={e=>{ filterActive = false; filter = ""; }}>×</a>
                </div>
            </th>
            <th on:click={onSortTime} data-tooltip="Время обновления" class="nowrap hidden-xs">
                Время
                <svg width="16" height="8" style="margin-left: 5px;">
                    <path fill={sortingOptions[0] == "date" ? "#286AA9" : "#999"}  d="M16 0H0l8 8"></path>
                </svg>
            </th>
            {#each visibleCurrency as currency, i}
            <th class="nowrap text-center" class:hidden-xs={i > 0}>
                <span class="controls" on:click={() => {onSortCurrency(currency, 0)}} data-tooltip="Выгодная покупка">
                    <svg width="16" height="8">
                        <path 
                            fill={sortingOptions[0] == "data." + currency + ".0" ? "#286AA9" : "#999"} 
                            d={sortingOptions[0] == "data." + currency + ".0" && "asc" == sortingOptions[1] ? "M8 0L0 8h16" : "M16 0H0l8 8"} />
                    </svg>
                </span>
                <span class="controls">
                    <select bind:value={visibleCurrency[i]}>
                        {#each currencyList as currency}
                            <option value={currency}>
                                {currency}
                            </option>
                        {/each}
                    </select>
                </span>
                <span class="controls" on:click={() => {onSortCurrency(currency, 1)}} data-tooltip="Выгодная продажа">
                    <svg width="16" height="8">
                        <path fill={sortingOptions[0] == "data." + currency + ".1" ? "#4E8E40" : "#999"} 
                        d={sortingOptions[0] == "data." + currency + ".1" && "desc" == sortingOptions[1] ? "M16 0H0l8 8" : "M8 0L0 8h16"} />
                    </svg>
                </span>
                
            </th>
            {/each}
            
            <th class="text-center hidden-xs">Телефон</th>
        </tr>
    </thead>
    <tbody>
    {#each filteredItemsList.slice(0,3) as item (item.id) }
        <tr>
            <td class={!item.workmodes.worknow?'punkt-close':'punkt-open'}>
                <Tooltip workmodes={item.workmodes} title={item.name}>
                    <a href={`/site/exchange?id=${item.id}`} class="tab">{item.name}</a>
                    <span class="address"><address>{item.address}</address></span>
                    <div>
                        {#if item.wholesale}
                            <span class="wholesale">
                                Оптовые цены                                
                            </span>
                        {/if}               
                        {#if item.wholesale_text}
                        <div class="wholesale_text">
                           {item.wholesale_text.replaceAll(',',', ')}
                        </div>
                        {/if}                          
                        {#if item.data.GOLD && item.data.GOLD[1] > 0}
                        <div class="kurs-warning"> 
                            <div class="relativeTime">Продаём золотые слитки</div>
                        </div>
                        {/if}
                    </div>
                </Tooltip>
                <div class="visible-xs">
                    {#each item.phones as phone}
                        <a class="phone" href="tel:{phone}">{phone}</a>
                    {/each}
                </div>
            </td>
            <td class="timeC hidden-xs">
                <Time time={item.date} actual={item.actual} {archive}/>
            </td>
            {#each visibleCurrency as currency, i}
            <td class:hidden-xs={i > 0}>        
                <div class="row">
                    <div class="col-5 text-end currency"><span title={currency + " - покупка"}>{item.data[currency] ? item.data[currency][0] : '-'}</span></div>
                    <div class="col-2">—</div>
                    <div class="col-5 text-start currency"><span title={currency + " - продажа"}>{item.data[currency] ? item.data[currency][1] : '-'}</span></div>
                </div>
                <div class="row visible-xs">
                    <Time time={item.date} actual={item.actual} {archive}/>
                </div>
            </td>
            {/each}
            <td class="phones hidden-xs">
                <Tooltip workmodes={item.workmodes} title={item.name}>
                    {#each item.phones as phone}
                        <a class="phone" href="tel:{phone}">{phone}</a>
                    {/each}
                </Tooltip>
            </td>
        </tr>
    {/each}
    {#if archive===false}
    <tr>
        <td colspan="6" class="kurs-table-place">
            <div class="table-place" id="table_3">
                
            </div>
        </td>
    </tr>
    {/if}
    {#each filteredItemsList.slice(3,5) as item (item.id) }
    <tr>
        <td class={!item.workmodes.worknow?'punkt-close':'punkt-open'}>
            <Tooltip workmodes={item.workmodes} title={item.name}>
                <a href={`/site/exchange?id=${item.id}`} class="tab">{item.name}</a>
                <span class="address"><address>{item.address}</address></span>
                <div>
                    {#if item.wholesale}
                        <span class="wholesale">
                            Оптовые цены                                
                        </span>
                    {/if}               
                    {#if item.wholesale_text}
                    <div class="wholesale_text">
                       {item.wholesale_text.replaceAll(',',', ')}
                    </div>
                    {/if}                          
                    {#if item.data.GOLD && item.data.GOLD[1] > 0}
                    <div class="kurs-warning"> 
                        <div class="relativeTime">Продаём золотые слитки</div>
                    </div>
                    {/if}
                </div>
            </Tooltip>
            <div class="visible-xs">
                {#each item.phones as phone}
                    <a class="phone" href="tel:{phone}">{phone}</a>
                {/each}
            </div>
        </td>
        <td class="timeC hidden-xs">
            <Time time={item.date} actual={item.actual} {archive}/>
        </td>
        {#each visibleCurrency as currency, i}
        <td class:hidden-xs={i > 0}>        
            <div class="row">
                <div class="col-5 text-end currency"><span title={currency + " - покупка"}>{item.data[currency] ? item.data[currency][0] : '-'}</span></div>
                <div class="col-2">—</div>
                <div class="col-5 text-start currency"><span title={currency + " - продажа"}>{item.data[currency] ? item.data[currency][1] : '-'}</span></div>
            </div>
            <div class="row visible-xs">
                <Time time={item.date} actual={item.actual} {archive}/>
            </div>
        </td>
        {/each}
        <td class="phones hidden-xs">
            <Tooltip workmodes={item.workmodes} title={item.name}>
                {#each item.phones as phone}
                    <a class="phone" href="tel:{phone}">{phone}</a>
                {/each}
            </Tooltip>
        </td>
    </tr>
    {/each}
    {#if archive===false}
    <tr>
        <td colspan="6" class="kurs-table-place">
            <div class="table-place" id="google_3">
                
            </div>
        </td>
    </tr>
    {/if}
    {#each filteredItemsList.slice(5,10) as item (item.id) }
        <tr>
            <td class={!item.workmodes.worknow?'punkt-close':'punkt-open'}>
                <Tooltip workmodes={item.workmodes} title={item.name}>
                    <a href={`/site/exchange?id=${item.id}`} class="tab">{item.name}</a>
                    <span class="address"><address>{item.address}</address></span>
                    <div>
                        {#if item.wholesale}
                            <span class="wholesale">
                                Оптовые цены                                
                            </span>
                        {/if}               
                        {#if item.wholesale_text}
                        <div class="wholesale_text">
                           {item.wholesale_text.replaceAll(',',', ')}
                        </div>
                        {/if}                      
                        {#if item.data.GOLD && item.data.GOLD[1] > 0}
                        <div class="kurs-warning"> 
                            <div class="relativeTime">Продаём золотые слитки</div>
                        </div>
                        {/if}
                    </div>
                </Tooltip>
                <div class="visible-xs mobile-phones">
                    {#each item.phones as phone}
                        <a class="phone" href="tel:{phone}">{phone}</a>
                    {/each}
                </div>
            </td>
            <td class="timeC hidden-xs">
                <Time time={item.date} actual={item.actual} {archive}/>
            </td>
            {#each visibleCurrency as currency, i}
            <td class:hidden-xs={i > 0}>        
                <div class="row">
                    <div class="col-5 text-end currency"><span title={currency + " - покупка"}>{item.data[currency] ? item.data[currency][0] : '-'}</span></div>
                    <div class="col-2">—</div>
                    <div class="col-5 text-start currency"><span title={currency + " - продажа"}>{item.data[currency] ? item.data[currency][1] : '-'}</span></div>
                </div>  
                <div class="visible-xs">
                    <Time time={item.date} actual={item.actual} {archive}/>
                </div>
            </td>
            {/each}
            <td class="phones hidden-xs">
                <Tooltip workmodes={item.workmodes} title={item.name}>
                    {#each item.phones as phone}
                        <a class="phone" href="tel:{phone}">{phone}</a>
                    {/each}
                </Tooltip>
            </td>
        </tr>
    {/each}
    {#if archive===false}
    <tr>
        <td colspan="6" class="kurs-table-place">
            <div class="table-place" id="google_5">
                
            </div>
        </td>
    </tr>
    {/if}
    {#each filteredItemsList.slice(10) as item (item.id) }
        <tr>
            <td class={!item.workmodes.worknow?'punkt-close':'punkt-open'}>
                <Tooltip workmodes={item.workmodes} title={item.name}>
                    <a href={`/site/exchange?id=${item.id}`} class="tab">{item.name}</a>
                    <span class="address"><address>{item.address}</address></span>
                    <div>
                        {#if item.wholesale}
                            <span class="wholesale">
                                Оптовые цены                                
                            </span>
                        {/if}               
                        {#if item.wholesale_text}
                        <div class="wholesale_text">
                           {item.wholesale_text.replaceAll(',',', ')}
                        </div>
                        {/if}           
                        {#if item.data.GOLD && item.data.GOLD[1] > 0}
                        <div class="kurs-warning"> 
                            <div class="relativeTime">Продаём золотые слитки</div>
                        </div>
                        {/if}
                    </div>
                </Tooltip>
                <div class="visible-xs">
                    {#each item.phones as phone}
                        <a class="phone" href="tel:{phone}">{phone}</a>
                    {/each}
                </div>
            </td>
            <td class="timeC hidden-xs">
                <Time time={item.date} actual={item.actual} {archive}/>
            </td>
            {#each visibleCurrency as currency, i}
            <td class:hidden-xs={i > 0}>
                <div class="row">
                    <div class="col-5 text-end currency"><span title={currency + " - покупка"}>{item.data[currency] ? item.data[currency][0] : '-'}</span></div>
                    <div class="col-2">—</div>
                    <div class="col-5 text-start currency"><span title={currency + " - продажа"}>{item.data[currency] ? item.data[currency][1] : '-'}</span></div>
                </div>
                <div class="row visible-xs">
                    <Time time={item.date} actual={item.actual} {archive}/>
                </div>
            </td>
            {/each}
            <td class="phones hidden-xs">
                <Tooltip workmodes={item.workmodes} title={item.name}>
                    {#each item.phones as phone}
                        <a class="phone" href="tel:{phone}">{phone}</a>
                    {/each}
                </Tooltip>
            </td>
        </tr>
    {/each}
    </tbody>
    <tfoot>
        <tr>
            <th colspan="2" class="hidden-xs">Средний курс</th>
            <th class="visible-xs">Средний курс</th>
            {#each visibleCurrency as currency, i}
            <th class:hidden-xs={i > 0}>        
                {#if averageData[currency] && averageData[currency][2] > 0 && averageData[currency][3] > 0}
                <div class="row">
                    <div class="col text-center currency nowrap">
                        <span title={currency + " - покупка"}>{Number(averageData[currency][0]/averageData[currency][2]).toFixed(2)} &#8212; {Number(averageData[currency][1]/averageData[currency][3]).toFixed(2)}</span>
                    </div>                    
                </div>   
                {/if}     
            </th>
            {/each}            
            <th class="hidden-xs"></th>
        </tr>
    </tfoot>
</table>
<style>
.wholesale_text{
    width: 100%;
    overflow-wrap: break-word;
    font-size: 10px;
    word-break: break-word;
    color: #323232;
}
.floatTHead{   

    z-index:100;
    display: none; 
    background-color: #e9e9e9;    
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}
.floatTHead.float {
    display: flex; 
    position: fixed;
    width: 100%;
    top: 0;
    z-index:1000;
}
.currency span {
    font-size: 16px;
    font-weight: bold;
    color: #2f2f2f;
}
.currency {
    white-space: nowrap;    
}
.table-kurs {
    overflow: hidden;
}
.table-kurs .col-2 {
    padding: 0;
}
.table-kurs .row {
    flex-wrap: nowrap;
}
.searchInputContainer{
    position: relative;
    overflow: hidden;
    height:22px;
    cursor: pointer;
}
.searchInputContainer div{
    white-space: nowrap;
}
.searchInputContainer div, .searchInputContainer input, .searchInputContainer a{
    position: absolute;
    left:0;
    top:0;
    height: 22px;
    line-height: 22px;
}
.searchInputContainer a{
    font-size: 18px;
    font-weight: bold;
    z-index: 100;
    left: -100%;
}
.searchInputContainer input{
    transition: 0.4s all ease-out;  
    left:-100%;
    width:10%;
    z-index: 99;
}
.searchInputContainer.open a{
    left: 90%;
    transition: 0.4s left ease-out;  

}
.searchInputContainer.open input{
    left:-0;
    width:100%;
}

a.tab {
    font-size: 13px;
    display: block;
}
.table-kurs .punkt-open, .table-kurs .punkt-close{
    background-image: url(/img/icons/time.svg); 
    background-repeat:  no-repeat;
    background-position: 5px 13px;
    background-size: 8px 8px;
    padding-left: 20px;

}
.table-kurs .punkt-close{
    background-image: url(/img/icons/timeoff.svg);     
}
.table-kurs .address,
.table-kurs address {
    font-size: 11px;
    font-style: normal;
    margin-bottom: 3px;
    display: inline-block;
}
.controls {
    padding: 0 3px;
}

.controls {
    cursor: pointer;
}


.table-kurs tbody tr td:nth-child(1) {
    text-align: left;
}

.table-kurs.hovered-0 tr td:nth-child(3) {
    background-color: #DEDEDE;
}

.table-kurs.hovered-1 tr td:nth-child(4) {
    background-color: #DEDEDE;
}

.table-kurs.hovered-2 tr td:nth-child(5) {
    background-color: #DEDEDE;
}

.wholesale {
    padding: 0 0 0 16px;
    font-size: 11px;
    background: url(/img/icons/sale.svg) no-repeat top left;
    background-size: contain;
    cursor: pointer;
    color: #3d5fa8;
    font-style: italic;
    margin-left: -17px;
}
.kurs-warning .relativeTime {
    background: url(/img/icons/warning.svg) no-repeat 2px 3px;
    background-size: 8px 8px;
    padding: 0 0 0 16px;
    font-size: 10px;
    margin: 3px 0;
    margin-left: -17px;
    color: #d4aa00
}

.nowrap {
    white-space: nowrap;
}

.kurs-table-place {
    text-align: center !important;
}

.kurs-table-place div.table-place {
    width: 728px;
    padding: 10px 0;
    margin: 0 auto;
}

.relativeTime {
    font-size: 10px;
    color: gray;
    font-style: italic;
    margin-top: 5px;
}

.visible-xs {
    display: none;
}

#table{
    margin-top: -15px;
}

@media (max-width:768px) {
    .hidden-xs {
        display: none;
    }

    #table{
        margin-top: 0px;
    }

    #table .pull-right {
        float: none;
    }

    .visible-xs {
        display: block;
    }

    .kurs-table-place div.table-place {
        height: 250px;
        width: 100%;
    }

    .table-kurs td {
        width: auto !important
    }
}

.scroll-container {
    width: 100%;
    position: relative;
}

.loadingContainer .loader {
    position: fixed;
    left: 49%;
    top: 49%;
}

.loadingContainer {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 50px;
    background-color: rgba(255, 255, 255, 0.5);
}

.scroll-header {
    z-index: 100000;
    position: fixed;
    left: 0;
    top: -50px;
    width: 100%;
    transition: 0.4s top ease-in;
}

.scroll-header.active {
    top: 0;
}

.aoprk-false {
    color: gray;
}

.table-kurs {
    width: 100%;
    border-collapse: collapse;
}

.table-kurs td,
.table-kurs th {
    border: 1px solid #fff;
}

.pname-phone {
    padding: 10px;
    background: #fff;
    border: 1px solid #ddd;
    position: absolute;
    display: none;
}

.address {
    font-size: 10px
}

.table-kurs th {
    background-color: #e9e9e9;
    padding: 5px 10px;
    color: #4b4b4b;
    font-size: 14px;
    text-align: left;
}

.table-kurs thead th:nth-child(1) {
    padding-left: 20px;
    padding-right: 20px;
    background: #e9e9e9 no-repeat 95% 50%;
    background-size: 12px;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEyOCAxMjgiIGhlaWdodD0iMTI4cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMjggMTI4IiB3aWR0aD0iMTI4cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGQ9Ik0xMTguOTc1LDEwNS4zOTZMOTguNjQ2LDg1LjA2OGM1LjYwMy04LjE2MSw4LjktMTguMDY3LDguODk3LTI4LjY4OSAgYzAuMDA1LTEzLjk3Mi01LjY5Mi0yNi43MTMtMTQuODU0LTM1Ljg2Yy05LjE0Ni05LjE2MS0yMS44ODctMTQuODU4LTM1Ljg2LTE0Ljg1NGMtMTMuOTcyLTAuMDA0LTI2LjcxMyw1LjY5Mi0zNS44NTgsMTQuODU0ICBDMTEuODEsMjkuNjY1LDYuMTE0LDQyLjQwNiw2LjExOCw1Ni4zNzlDNi4xMTQsNzAuMzUzLDExLjgxLDgzLjA5MywyMC45NzIsOTIuMjM4YzkuMTQ2LDkuMTYyLDIxLjg4NywxNC44NTksMzUuODU4LDE0Ljg1MyAgYzEwLjE1NywwLjAwNCwxOS42NTQtMy4wMTUsMjcuNjAxLTguMTc1bDIwLjUxMiwyMC41MTFjMy44NzUsMy44NzgsMTAuMTU3LDMuODc4LDE0LjAzMSwwICBDMTIyLjg1MiwxMTUuNTUzLDEyMi44NTIsMTA5LjI3MSwxMTguOTc1LDEwNS4zOTZ6IE0zNS4wMDQsNzguMjA2Yy01LjYwMS01LjYxNi05LjAzNi0xMy4yNzItOS4wNDEtMjEuODI3ICBjMC4wMDUtOC41NTUsMy40NC0xNi4yMSw5LjA0Mi0yMS44MjdjNS42MTctNS42MDIsMTMuMjcxLTkuMDM3LDIxLjgyNS05LjA0MmM4LjU1NiwwLjAwNSwxNi4yMSwzLjQ0LDIxLjgyOCw5LjA0MSAgYzUuNjAxLDUuNjE4LDkuMDM2LDEzLjI3Miw5LjA0LDIxLjgyOGMtMC4wMDQsOC41NTUtMy40MzksMTYuMjExLTkuMDQsMjEuODI3Yy01LjYxNyw1LjYwMi0xMy4yNzEsOS4wMzYtMjEuODI4LDkuMDQgIEM0OC4yNzYsODcuMjQyLDQwLjYyMiw4My44MDgsMzUuMDA0LDc4LjIwNnoiIGZpbGw9IiMyMzIzMjMiLz48L3N2Zz4=);

}

.text-center {
    text-align: center !important;
}

.table-kurs td {
    width: 10%;
    background-color: #f5f5f5;
    padding: 5px 10px;
    text-align: center;
}
.table-kurs td.timeC {
    text-align: left;
}

.table-kurs tbody td:nth-child(1) {
    width: 20%;
}

.table-kurs .currency {}

.sort-table {
    width: 100%;
}

.sort-table td {
    width: 50% !important;
    text-align: center;
    border: none;
    background: none;
}

.extraPhone {
    font-size: 11px;
    width: 300px !important;
}

a.phone {
    font-size: 12px;
    white-space: nowrap;
    line-height: 14px;
    display: block;
    padding-bottom:8px;
}
div.mobile-phones {
    padding-top:5px;
}
</style>